module.exports = __webpack_public_path__ + "img/A - 01.c1e70956.png";